import React from "react";
import {useState} from "react";
import "./styles.css";

import {FaComment, FaWalking} from "react-icons/fa";
import {RiGroupFill} from "react-icons/ri";
import {BiChevronDown, BiChevronUp} from "react-icons/bi";
import {buttons} from "../../core/db";

const Ability = (props) => {
    const {type, types, selected, setSelected} = props;
    let icon;
    let texto;

    const [toggle, setToggle] = useState("");

    const expandir = toggle ? "" : "expandir";

    const [isActive, setIsActive] = useState(false);

    if (type === "Comunicativa") {
        icon = <FaComment/>;
        texto =
            "É a capacidade do individuo interpretar, reconhecer e interagir com pessoas e com o mundo por meio de gestos, vocalizações, balbucios ou fala propriamente dita.";
    } else if (type === "Social") {
        icon = <RiGroupFill/>;
        texto =
            "São habilidades que utilizamos no nosso dia á dia para interagir e nos comunicar com as outras pessoas. Incluem comunicação verbal e não verbal, como a fala, gestos, expressões faciais e corporais, por exemplo.";
    } else {
        icon = <FaWalking/>;
        texto =
            "Consiste nas funções motoras necessárias para realizar as tarefas do dia a dia.";
    }

    return (
        <div className="filter-content">
            <div className="filter-title">
                <div className="filter-icon">{icon}</div>
                <p>Habilidade {type}</p>
                <div className="botao-expandir">
                    {isActive ? (
                        <BiChevronUp
                            className="navbar-icon"
                            onClick={() => {
                                setIsActive(!isActive);
                                setToggle(!toggle);
                            }}
                        />
                    ) : (
                        <BiChevronDown
                            className="navbar-icon"
                            onClick={() => {
                                setIsActive(!isActive);
                                setToggle(!toggle);
                            }}
                        />
                    )}
                </div>
            </div>
            <div className="texto-filtro">
                <div className={`${expandir}`}>{texto}</div>
            </div>
            <div className="filter-button-container">
                {buttons.map((item, index) => {
                    if (item.title === type) {
                        let className = "filter-button";
                        let typeIndex = types.indexOf(type);

                        if (selected[typeIndex] === item.level) {
                            className += " filter-button-active";
                        } else {
                            className = "filter-button";
                        }

                        return (
                            <div className="niveis" key={index}> {/* Adicionando key aqui */}
                                <div
                                    className={className}
                                    onClick={() => {
                                        let temp = [...selected];
                                        let index = types.indexOf(type);
                                        console.log(temp);

                                        if (temp[index] === 0) {
                                            temp[index] = item.level;
                                        } else if (temp[index] === item.level) {
                                            temp[index] = 0;
                                        } else {
                                            temp[index] = item.level;
                                        }

                                        setSelected(temp);
                                    }}
                                >
                                    Nível {item.level}
                                </div>
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
            {buttons.map((item, index) => {
                if (item.title === type) {
                    let className = "filter-button";
                    let typeIndex = types.indexOf(type);

                    if (selected[typeIndex] === item.level) {
                        className += " filter-button-active";
                    }

                    return (
                        <div key={index}> {/* Adicionando key aqui */}
                            <div className="niveis"></div>
                            <div className="texto-niveis">
                                {selected[typeIndex] === item.level
                                    ? `Nível ${item.level}: ${item.texto}`
                                    : null}
                            </div>
                        </div>
                    );
                }

                return null;
            })}
        </div>
    );
};

export default Ability;
